import React from "react"
import arrow from "../img/arrow-7.svg"
import AddToSlack from "./AddToSlack"
import { classNames } from "./utils"
import Link from "./Link"

const SolutionCta = ({
  title,
  subtitle,
  url,
  useSlackCta,
  ctaType,
  className,
}) => {
  if (useSlackCta) {
    return (
      <div className="spacing-xl">
        <AddToSlack detailed={ctaType === "detailed"} />
      </div>
    )
  }

  return (
    <div className={classNames("solution-cta", className)}>
      <div className="solution-cta-inner">
        {subtitle && (
          <>
            <img
              alt=""
              src={arrow}
              style={{ paddingLeft: 145, position: "absolute" }}
              className="desktop-only"
            />
            <p>{subtitle}</p>
          </>
        )}
        <Link className="button button-primary" to={url}>
          {title}
        </Link>
      </div>
    </div>
  )
}

export default SolutionCta
